module.exports = __webpack_public_path__ + "static/media/covirtua-logo.99fcf0a7.png";